import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import AuthLayout from "./AuthLayout";
import { Button, Field, Input } from "@/components/design-system";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiError } from "@/lib/api";
import { TID } from "@/lib/testIds";

export default function Login() {
  const nav = useNavigate();
  const loc = useLocation();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email, password);
      const dest = loc.state?.from || "/app";
      nav(dest, { replace: true });
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout
      eyebrow="Log in"
      title="Welcome back."
      subtitle="Sign in to keep building your launch loop."
      footer={<>Don&apos;t have an account? <Link data-testid={TID.auth.loginRegister} to="/register" className="text-[#2D7FF9] font-semibold">Sign up →</Link></>}
    >
      <form onSubmit={onSubmit} className="space-y-5">
        <Field label="Email" htmlFor="login-email">
          <Input
            id="login-email"
            data-testid={TID.auth.loginEmail}
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@company.com"
          />
        </Field>
        <Field label="Password" htmlFor="login-password">
          <Input
            id="login-password"
            data-testid={TID.auth.loginPassword}
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
          />
        </Field>

        {error && (
          <p data-testid={TID.auth.loginError} className="text-sm font-medium text-red-600">{error}</p>
        )}

        <Button data-testid={TID.auth.loginSubmit} type="submit" variant="primary" className="w-full" disabled={busy}>
          {busy ? "Signing in…" : "Sign in"}
        </Button>

        <div className="flex justify-between text-sm">
          <Link data-testid={TID.auth.loginForgot} to="/forgot-password" className="text-[#2D7FF9] font-medium hover:underline">Forgot password?</Link>
          <Link to="/" className="text-[#0B1F3A]/60 hover:text-[#0B1F3A]">Back to home</Link>
        </div>
      </form>
    </AuthLayout>
  );
}
